import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import ProviderName from "../../components/provider/ProviderDetail/ProviderName.tsx";
import {useLocationFormState} from "../../components/provider/ProviderForm/ProviderUpdateForm";
import ProviderUpdateFormProvider from "../../components/provider/ProviderForm/ProviderUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ProviderUpdateEditPage = () => {
    
    useTitle(t`Update Provider`);

    const { providerId: id } = useParams();
    
    return (
        <Box data-testid="Provider-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="Provider-update-title"
                    >
                        <Trans>Edit Provider</Trans>:  <ProviderName id={id}/>
                    </Typography>
                    <ProviderUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default ProviderUpdateEditPage;
